import { inject, Injectable } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { UserService } from '../../../services/user.service';
import { RecordsSearchState } from './records-search.state';
import { Observable } from 'rxjs';
import { RecordSearch } from '../../service/records-search/models/record-search.model';
import { SearchRequestBody, SearchResponse } from '../../service/search.model';
import {
  AddSearchRecordToList,
  AddToFavorites,
  RemoveFromFavorites,
  RemoveSearchRecordFromList,
  ResetStore,
  SearchRecords,
} from './records-search.actions';
import type { SearchPerformedOrigin } from 'src/app/_core/analytics/events/search-performed-event';

@Injectable({
  providedIn: 'root',
})
export class RecordsSearchFacade {
  private readonly store = inject(Store);
  private readonly userService = inject(UserService);

  @Select(RecordsSearchState.records) records$: Observable<RecordSearch[]>;
  @Select(RecordsSearchState.pagination) pagination$: Observable<Omit<SearchResponse<RecordSearch>, 'data'>>;
  @Select(RecordsSearchState.isLoading) isLoading$: Observable<boolean>;
  @Select(RecordsSearchState.query) query$: Observable<string>;

  get records(): RecordSearch[] {
    return this.store.selectSnapshot(RecordsSearchState.records);
  }

  get pagination(): Omit<SearchResponse<RecordSearch>, 'data'> {
    return this.store.selectSnapshot(RecordsSearchState.pagination);
  }

  addToList(listId: string, recordId: string) {
    return this.store.dispatch(new AddSearchRecordToList(this.userService.getUserId(), listId, recordId));
  }

  removeFromList(listId: string, recordId: string, elementWishListId: string) {
    return this.store.dispatch(
      new RemoveSearchRecordFromList(this.userService.getUserId(), listId, recordId, elementWishListId)
    );
  }

  searchRecords(page = 0, query = '', additionalData: SearchRequestBody = null, order = 'relevance', searchOrigin: SearchPerformedOrigin = 'none') {
    return this.store.dispatch(new SearchRecords(page, query, additionalData, order, searchOrigin));
  }

  resetStore() {
    return this.store.dispatch(new ResetStore());
  }

  addToFavorites(id: string) {
    return this.store.dispatch(new AddToFavorites(id));
  }

  removeFromFavorites(id: string) {
    return this.store.dispatch(new RemoveFromFavorites(id));
  }
}
